import React from "react";
import styled from "styled-components";
import Fade from "react-reveal/Fade";
const Banner = () => {
  return (
    <Fade>
      <Container>
        <ImgContainer>
          <img src="./images/IMG_1980.png" alt="" />
          <img src="./images/IMG_1983.png" alt="" />
          <img src="./images/IMG_1983.png" alt="" />
          <img src="./images/IMG_1981.png" alt="" />
          <img src="./images/IMG_2386.png" alt="" />
          <img src="./images/IMG_1983.png" alt="" />
          <img src="./images/IMG_1981.png" alt="" />
          <img src="./images/IMG_2386.png" alt="" />
          <img src="./images/IMG_1981.png" alt="" />
        </ImgContainer>
        <ContentContainer>
          <img src="./images/Frame 38.png" alt="Plump beauty logo" />
          <img src="./images/X.png" alt="X" />
          <img src="./images/STRIP.png" alt="STRIP" />
        </ContentContainer>
        <ImgContainer>
          <img src="./images/IMG_2386.png" alt="" />
          <img src="./images/IMG_1980.png" alt="" />
          <img src="./images/IMG_1983.png" alt="" />
          <img src="./images/IMG_1981.png" alt="" />
          <img src="./images/IMG_1983.png" alt="" />
          <img src="./images/IMG_1981.png" alt="" />
          <img src="./images/IMG_2386.png" alt="" />
          <img src="./images/IMG_1983.png" alt="" />
          <img src="./images/IMG_1981.png" alt="" />
        </ImgContainer>
      </Container>
    </Fade>
  );
};

const Container = styled.div`
  height: fit-content;
  display: flex;
  flex-direction: column;
`;

const ImgContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  img {
    height: 260px;
  }

  @media only screen and (max-width: 768px) {
    img {
      height: 150px;
    }
  }

  @media only screen and (max-width: 1440px) {
    img {
      flex: 1;
    }
  }
  @media only screen and (min-width: 1441px) {
    img {
      width: auto;
    }
  }
`;

const ContentContainer = styled.div`
  background: #000;
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  img {
    height: 100px;

    &:nth-child(2) {
      height: 30px;
    }

    &:nth-child(3) {
      margin-left: 40px;
      height: 60px;
    }
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;

    img {
      margin-bottom: 20px;

      &:nth-child(2) {
        margin-left: -10px;
      }

      &:nth-child(3) {
        margin-top: 20px;
        margin-left: 0px;
        height: 50px;
      }
    }
  }
`;
export default Banner;
